
import {map} from 'rxjs/operators';
import {Injectable} from "@angular/core";
import {TaxYearService} from "../../../swaggerServices";
import {DropdownListOption} from "../components/search-dropdown/search-dropdown.component";
import moment from "moment";
import {Subject, BehaviorSubject} from "rxjs";

@Injectable()
export class TaxYearsService {

  taxYears: any[];
  $taxYears: Subject<any> = new BehaviorSubject({});

  constructor(private taxYearService: TaxYearService) {}

  // generate list options for tax year dropdown
  getTaxYears(allowAll?: boolean) {

    if (this.taxYears) this.$taxYears.next(this.taxYears);

    return this.taxYearService.getTaxYears().pipe(map((taxYears: any) => {
      const options: DropdownListOption[] = [];

      if (allowAll && taxYears.length > 1) {
        options.push({
          id: 1,
          name: 'All',
          value: null,
          order: -1,
          selected: null
        });
      }

      const currentYear = this.getCurrentTaxYear();

      taxYears
        .filter(year => year.year !== 1900)
        .forEach((year, index) => {
          options.unshift({
            id: year.id,
            name: year.year.toString(),
            value: year.year,
            order: index,
            selected: year.year === currentYear
          });
      });

      this.taxYears = options;
      this.$taxYears.next(this.taxYears);
      return this.taxYears;

    }));


  };

  getCurrentTaxYear() {
    const m = moment();
    return m.isBefore(moment(`1/07/${m.year()}`, "DD/MM/YYYY")) ? m.year() - 1 : m.year();
  };

}
